// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__NteM8","hide-backdrop":"Modal_hide-backdrop__Mu5+b"};